<template>
  <common-card>
    <v-row>
      <v-col>
        <v-row style="padding: 20px">
          <v-col cols="12" md="6">
            <h1>
              Usuarios
            </h1>
          </v-col>
          <v-col cols="12" md="6" style="text-align: end;">
            <v-btn
              class="common-botton"
              dark
              :loading="loading"
              @click="$router.push('/usuario/crear')"
              v-if="canCreateUser"
            >
              <v-icon class="mr-2">mdi-plus</v-icon>
              <span>Crear</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-expansion-panels
      elevation="0"
      style="padding: 30px; border-radius: 20px"
    >
      <v-expansion-panel>
        <v-expansion-panel-header style="padding: 35px;">
          <h3 style="color:#42352E;">
            Búsqueda detallada
          </h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="search"
                label="Buscar"
                hint="Buscar un agente por nombre, correo o RFC"
                class="mx-4 my-2"
                outlined
                dense
                color="primary"
                background-color="white"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" style="text-align: end;">
              
              <v-btn
                class="common-botton"
                dark
                :loading="loading"
                @click="getAgente"
              >
              <v-icon class="mr-2">mdi-filter</v-icon>
                <span>Filtrar</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div style="padding: 0px 40px 0px 40px;">
      <hr />
    </div>
    <v-row>
      <v-col cols="12" class="mb-10" style="padding: 40px">
        <v-data-table
          style=""
          :headers="agentesTable"
          :items="usuarios"
          item-key="name"
          class="elevation-0"
          :loading="loading"
          loading-text="Cargando..."
          no-data-text="Para ver elementos, primero realiza una búsqueda"
        >
          <template v-slot:top>
            <v-row style="padding: 15px;">
              <v-col cols="8">
                <h2>Resultados de la búsqueda</h2>
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.sexo="{ item }">
            <div v-if="item.sexo == 1">Masculino</div>
            <div v-if="item.sexo == 2">Femenino</div>
          </template>
          <template #item.fechaRegistro="{item}">
            <span>{{ moment(item.fechaRegistro).format("DD/MM/YYYY") }}</span>
          </template>
          <template v-slot:item.status="{ item }">
            <div v-if="item.status == -1">
              <v-chip color="red" dark>Baja</v-chip>
            </div>
            <div v-if="item.status == 0">
              <v-chip color="blue" dark>Nuevo</v-chip>
            </div>
            <div v-if="item.status == 1">
              <v-chip color="green" dark>Activo</v-chip>
            </div>
            <div v-if="item.status == 2">
              <v-chip color="amber darken-2" dark>Inactivo</v-chip>
            </div>
          </template>
          <template v-slot:item.rol="{ item }">
            <div>
              <v-chip color="blue" dark>{{ getCurrentRol(item.rol) }}</v-chip>
            </div>
          </template>
          <template v-slot:item.uuid="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="$router.push(`/usuario/ver-micuenta/${item.uuid}`)"
            >
              mdi-eye
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </common-card >
</template>

<script>
import moment from "moment";
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import { getAgentesFiltrosUnificados, getRolesList } from "@/services/user/user.service";
const setListaDesplegable = require("@/helpers/diccionarios/permisosUsuarios.js")

export default {
  components: {
    CommonCard,
  },
  data() {
    return {
      moment: moment,
      agentes: [],
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      loading: false,
      search: "",
      agentesTable: [
        {
          text: "Nombre",
          align: "start",
          sortable: false,
          value: "nombreCompleto",
        },
        { text: "Correo Electronico", value: "correo" },
        { text: "Rol", value: "rol" },
        { text: "Fecha de Registro", value: "fechaRegistro" },
        { text: "Activo", value: "status" },
        { text: "RFC", value: "rfc" },
        { text: "Ver", value: "uuid" },
      ],
      report: [],
      usuarios: [],
      elementosPagina:10,
      pagina:0,
      roles: []
    };
  },
  methods: {
    async getAgente() {
      this.loading = true;
      let filters = {
        filtroBusqueda: this.search,
      }
      let roles = setListaDesplegable(this.rol);
      let response =  await getAgentesFiltrosUnificados(filters, roles)
      this.roles =  await getRolesList()
      this.usuarios = response
      this.loading = false;
    },
    getCurrentRol(rol){
      let currentRol = this.roles.find((e) => e.rol == rol)
      return currentRol ? currentRol.nombre : "" 
    }
  },
  computed: {
    canCreateUser(){
      return this.$store.getters['roles/tienePermiso']('Usuarios', 'Crear') 
    },
  }
  
};
</script>
<style scoped>
.theme--light.v-data-table {
  background-color: #f2fafc;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 20px;
}

.v-expansion-panel {
  border-radius: 20px;
}
.v-expansion-panels {
  z-index: auto !important;
}
.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)
  > .v-expansion-panel--active {
  border-radius: 20px !important;
}

.theme--light.v-expansion-panels .v-expansion-panel {
  background-color: #f6f5f9;
  color: rgba(0, 0, 0, 0.87);
}
</style>
